import * as types from 'store/types'

const initialState = {
  showSettingsModal: false,
  active_tab: 'profile'
}
const settingsReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.TOGGLE_SETTINGS_MODAL: {
      return {
        ...state,
        showSettingsModal: action.status
      }
    }
    case types.CHANGE_TAB: {
      return {
        ...state,
        active_tab: action.value
      }
    }
    default: {
      return { ...state }
    }
  }
}
export default settingsReducer
